
// 
export const NOTIFICATION_LIST_REQUEST = 'NOTIFICATION_LIST_REQUEST'
export const NOTIFICATION_LIST_SUCCESS = 'NOTIFICATION_LIST_SUCCESS'
export const NOTIFICATION_LIST_FAIL = 'NOTIFICATION_LIST_FAIL'